import { CommerceService } from "@/services/commerce"

/**
 * If triggered more than once (custom type exists, error will be returned)
 *
 * Kept here to track progress and for future migrations.
 * Purpose to add custom fields for customer addresses in commercetools
 */
export const mutationAddCustomerAddressCustomType = {
  async addCustomerAddressCustomType(parent, args, context, info) {
    const commerceApi = CommerceService.api()

    const typeDraft = {
      key: "customerAddressCustomTypeKey",
      name: { "de-DE": "customerAddressCustomTypeName", "en-US": "customerAddressCustomTypeName" },
      description: {
        "de-DE": "Benutzerdefinierte Felder für Kundenadressen",
        "en-US": "Custom fields for customer addresses",
      },
      resourceTypeIds: ["address"],
      fieldDefinitions: [
        {
          type: { name: "String" },
          name: "status",
          label: {
            "de-DE": "Status",
            "en-US": "Status",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "creationBy",
          label: {
            "de-DE": "Erstellt von",
            "en-US": "Erstellt von",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "versionNr",
          label: {
            "de-DE": "Versions Nr.",
            "en-US": "Versions Nr.",
          },
          required: false,
        },
        {
          type: { name: "Boolean" },
          name: "benefitRecipient",
          label: {
            "de-DE": "Leistungsempfänger",
            "en-US": "Leistungsempfänger",
          },
          required: false,
        },
        {
          type: { name: "Boolean" },
          name: "defaultContact",
          label: {
            "de-DE": "Standartkontakt",
            "en-US": "Standartkontakt",
          },
          required: false,
        },
        {
          type: { name: "DateTime" },
          name: "creationAt",
          label: {
            "de-DE": "Anlage am",
            "en-US": "Anlage am",
          },
          required: false,
        },
        {
          type: { name: "DateTime" },
          name: "modifiedAt",
          label: {
            "de-DE": "Geändert am",
            "en-US": "Geändert am",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "modifiedBy",
          label: {
            "de-DE": "Geändert von",
            "en-US": "Geändert von",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "modificationSource",
          label: {
            "de-DE": "Modification source",
            "en-US": "Modification source",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "dateOfBirth",
          label: {
            "de-DE": "Geburtsdatum",
            "en-US": "Date of birth",
          },
          required: false,
        },
      ],
    }

    try {
      await commerceApi.types().post({ body: typeDraft }).execute()

      return true
    } catch (error) {
      throw new Error(error)
    }
  },
}
